import React from 'react';
import { Toast } from '@hoffmann/pattern-library-2';

interface Props {
  title?: string;
  onDismiss: () => void;
  [key: string]: any;
}
export const ToastController: React.FC<Props> = ({
  onDismiss,
  onClose,
  onTimeout,
  children = '',
  ...rest
}) => {
  const handleClose = onClose
    ? () => {
        if (typeof onClose === 'function') {
          onClose();
        }
        onDismiss();
      }
    : undefined;

  const handleTimeout = onTimeout
    ? () => {
        onDismiss();
        if (typeof onTimeout === 'function') {
          onTimeout();
        }
      }
    : onDismiss;

  return (
    <Toast {...rest} onTimeout={handleTimeout} onClose={handleClose}>
      {children}
    </Toast>
  );
};
